var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRemove = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8218 9.93793L7.06511 6.1814C6.82075 5.93693 6.42567 5.93693 6.18131 6.1814C5.93696 6.42575 5.93696 6.82084 6.18131 7.0652L9.93796 10.8218L6.18131 14.5784C5.93696 14.8228 5.93696 15.2178 6.18131 15.4622C6.42567 15.7066 6.82075 15.7066 7.06511 15.4622L10.8218 11.7056L14.5784 15.4622C14.8228 15.7066 15.2178 15.7066 15.4622 15.4622C15.5841 15.3404 15.6453 15.1803 15.6453 15.0203C15.6453 14.8603 15.5841 14.7003 15.4622 14.5784L11.7056 10.8218L15.4622 7.06519C15.5841 6.9433 15.6453 6.7833 15.6453 6.6233C15.6453 6.46329 15.5841 6.30329 15.4622 6.1814C15.2178 5.93693 14.8228 5.93693 14.5784 6.1814L10.8218 9.93793Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/remove.fb35088f.svg";
export { ForwardRef as ReactComponent };